import { type ComponentType, createContext } from 'react';

export interface BaseModalProps {
  open: boolean;
  onClose: () => void;
}

export type ModalProviderContextValue = {
  openModal<T extends BaseModalProps>(
    modal: ComponentType<T>,
    props?: Omit<T, keyof BaseModalProps>,
  ): void;
  onCloseAll: () => void;
  modals: Array<{
    Modal: ComponentType<any>;
    props: unknown;
    open: boolean;
    id: string;
  }>;
};

export const ModalProviderContext = createContext<ModalProviderContextValue>({
  openModal(): void {
    return;
  },
  onCloseAll(): void {
    return;
  },
  modals: [],
});
